import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MultiSelect from "../../components-react/MultiSelect";
import {
  activeInactiveStatus,
  custom_types,
  recipient_roles,
  regularPlansDropdown,
  renewal_unpaid,
} from "../../common-data/DropdowData";
import CloseSubmitBtn from "../../common-components/custom-comps/CloseSubmitBtn";
import { selectGymData } from "../../../redux/reducers/gymDataSlice";
import { fetchGymData } from "../../../data/APIs";
import {
  fetchAllMembersData,
  fetchClusterManagersData,
  fetchLeadSourceData,
} from "../../../redux/reducers/dropdownApiSlice";
import { validateBroadcastForm } from "../Validations";
import {
  fetchAllLeadsData,
  fetchAllTrainerData,
} from "../../../redux/reducers/apiSlice";
import Loader from "../../ui/Loader";
import { fetchReceptionistsData } from "../../../redux/prospect-reducers/prospectSlice";
import ReBroadcastForm from "./broadcast-form/ReBroadcastForm";
import { ReloadIcon } from "../../../images/icons/icons";
import BroadcastCampaignForm from "../../common-components/broadcast-template/BroadcastCampaignForm";

const BroadcastTemplateForm = ({
  isEdit,
  rowData,
  closeModal,
  userInfoData,
  callFunction,
}) => {
  const dispatch = useDispatch();
  const gymData = useSelector(selectGymData);
  const { postPutLoading } = useSelector((state) => state.common);
  const {
    members,
    loading,

    loading: leadSourcesLoading,
    leadSources,

    clusterManagers,
    clusterManagersLoading,
  } = useSelector((state) => state.dropdown);
  const {
    allLeads,
    allLeadsLoading,
    loading: trainerDataLoading,
    trainerData,
  } = useSelector((state) => state.api);

  const { receptionistsLoading, receptionistsError, receptionists } =
    useSelector((state) => state.prospects);

  const forminitials = {
    selectedRecipient: "",
    selectedMemberType: "",

    selectedMembers: [],
    selectedFollowUpMembers: [],
    selectedTrainers: [],
    selectedReceptionists: [],
    selectedClusterManagers: [],

    isAllMembers: false,

    startDate: "",
    endDate: "",

    selectedGym: "",
    selectedGyms: [],

    selectedSubscriptionType: "",
    subscriptionTypeValue: "",

    selectedPlanDuration: "",
    selectedMemberStatus: "",
    selectedSubscriptionStatus: "",

    selectedLeadSource: "",
  };
  const [formValues, setFormValues] = useState(forminitials);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const [followUpMembers, setFollowUpMembers] = useState([]);
  const [trainers, setTrainers] = useState([]);
  const [receptionistData, setReceptionistData] = useState([]);

  const selectedMembers = formValues.isAllMembers
    ? []
    : formValues.selectedRecipient?.value === "member"
    ? formValues.selectedMemberType?.value === "lead"
      ? formValues.selectedFollowUpMembers
      : formValues.selectedMembers
    : formValues.selectedRecipient?.value === "trainer"
    ? formValues.selectedTrainers
    : formValues.selectedRecipient?.value === "receptionist"
    ? formValues.selectedReceptionists
    : formValues.selectedRecipient?.value === "cluster_manager"
    ? formValues.selectedClusterManagers
    : [];

  // --------------- GET DATA ---------------
  const getMembersData = (filters) => {
    dispatch(
      fetchAllMembersData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  };

  function getAllLeads(filters) {
    dispatch(
      fetchAllLeadsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  function getLeadSources(filters) {
    dispatch(
      fetchLeadSourceData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  const getTrainerData = (filters) => {
    dispatch(fetchAllTrainerData({ filters, token: userInfoData?.token }));
  };

  function getReceptionists(filters) {
    dispatch(
      fetchReceptionistsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  function getClusterManagers(filters) {
    dispatch(
      fetchClusterManagersData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  const getCombinedReload = () => {
    if (formValues.selectedRecipient?.value === "member") {
      if (formValues.selectedMemberType?.value === "member") {
        const gymIds = formValues.selectedGyms
          ?.map((gym) => gym?.value)
          .join(",");
        const planDuration = formValues.selectedPlanDuration?.value || "";
        const subscriptionType =
          formValues.selectedSubscriptionType?.value || "";
        const daysValue = formValues.subscriptionTypeValue || "";

        const sendableFilters = {
          page: 1,
          limit: 5000,
          search: "",
          gym_id: gymIds,
          plan_duration: planDuration,
          member_type: subscriptionType,
          days_value: daysValue || "",
          subscription_start_date: formValues.startDate || "",
          subscription_end_date: formValues.endDate || "",
          source_name: formValues.selectedLeadSource?.value || "",
          status: formValues.selectedMemberStatus?.value || "",
          subscription_status:
            formValues.selectedSubscriptionStatus?.value || "",
        };

        getMembersData(sendableFilters);
      } else if (formValues.selectedMemberType?.value === "lead") {
        const gymIds = formValues.selectedGyms
          ?.map((gym) => gym?.value)
          .join(",");

        const sendableLeadFilters = {
          page: 1,
          limit: 5000,
          lead_status: "pending",
          status: "active",
          source_name: formValues.selectedLeadSource?.value || "",
          gym_id: gymIds || "",
        };

        getAllLeads(sendableLeadFilters);
      }
    } else if (formValues.selectedRecipient?.value === "trainer") {
      const gymIds = formValues.selectedGyms
        ?.map((gym) => gym?.value)
        .join(",");

      const sendableFilters = {
        page: 1,
        limit: 5000,
        status: "active",
        gym_id: gymIds || "",
      };

      getTrainerData(sendableFilters);
    } else if (formValues.selectedRecipient?.value === "receptionist") {
      const gymIds = formValues.selectedGyms
        ?.map((gym) => gym?.value)
        .join(",");

      const sendableFilters = {
        page: 1,
        limit: 5000,
        status: "active",
        gym_id: gymIds || "",
      };

      getReceptionists(sendableFilters);
    } else if (formValues.selectedRecipient?.value === "cluster_manager") {
      const gymIds = formValues.selectedGyms
        ?.map((gym) => gym?.value)
        .join(",");

      const sendableFilters = {
        page: 1,
        limit: 5000,
        status: "active",
        gym_id: gymIds || "",
      };

      getClusterManagers(sendableFilters);
    }
  };
  // ------------------ END GET DATA ------------------

  const onChangeInput = (e) => {
    setIsSubmit(false);

    const { name, value, type, checked } = e.target;

    if (name === "startDate" || name === "endDate") {
      setFormValues((prev) => ({
        ...prev,
        selectedMembers: [],
        selectedTrainers: [],
        selectedReceptionists: [],
        selectedFollowUpMembers: [],
        [name]: type === "checkbox" ? checked : value,
      }));
    } else {
      setFormValues((prev) => ({
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      }));
    }
  };

  const onChangeDropdown = (value, name) => {
    setIsSubmit(false);

    if (name === "selectedRecipient") {
      setFormValues((prev) => ({
        ...prev,
        selectedMemberType: "",
        selectedMembers: [],
        selectedFollowUpMembers: [],
        selectedTrainers: [],
        selectedReceptionists: [],
        selectedClusterManagers: [],
        isAllMembers: false,
        startDate: "",
        endDate: "",
        selectedGym: "",
        selectedGyms: [],
        selectedSubscriptionType: "",
        subscriptionTypeValue: "",
        selectedPlanDuration: "",
        selectedMemberStatus: "",
        selectedSubscriptionStatus: "",
        selectedLeadSource: "",
        [name]: value,
      }));
    } else if (name === "selectedMemberType") {
      setFormValues((prev) => ({
        ...prev,
        selectedMembers: [],
        selectedFollowUpMembers: [],
        selectedTrainers: [],
        selectedReceptionists: [],
        selectedClusterManagers: [],
        isAllMembers: false,
        startDate: "",
        endDate: "",
        selectedGym: "",
        selectedGyms: [],
        selectedSubscriptionType: "",
        subscriptionTypeValue: "",
        selectedPlanDuration: "",
        selectedMemberStatus: "",
        selectedSubscriptionStatus: "",
        selectedLeadSource: "",
        [name]: value,
      }));
    } else if (
      name === "selectedGym" ||
      name === "selectedSubscriptionType" ||
      name === "subscriptionTypeValue" ||
      name === "selectedPlanDuration" ||
      name === "selectedLeadSource" ||
      name === "selectedMemberType"
    ) {
      setFormValues((prev) => ({
        ...prev,
        selectedMembers: [],
        selectedTrainers: [],
        selectedReceptionists: [],
        selectedFollowUpMembers: [],
        [name]: value,
      }));
    } else {
      setFormValues((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const onSumitForm = (e) => {
    e.preventDefault();

    const erros = validateBroadcastForm(formValues);

    setFormErrors(erros);

    if (Object.keys(erros).length === 0) {
      setIsSubmit(true);
    }
  };

  useEffect(() => {
    dispatch(fetchGymData(userInfoData?.token, 1, 100, "", ""));
  }, []);

  useEffect(() => {
    if (
      formValues.selectedRecipient?.value === "member" &&
      formValues.selectedMemberType?.value === "member"
    ) {
      // const gymIds = formValues.selectedGym?.value || "";
      const gymIds = formValues.selectedGyms
        ?.map((gym) => gym?.value)
        .join(",");
      const planDuration = formValues.selectedPlanDuration?.value || "";
      const subscriptionType = formValues.selectedSubscriptionType?.value || "";
      const daysValue = formValues.subscriptionTypeValue || "";

      const sendableFilters = {
        page: 1,
        limit: 5000,
        search: "",
        gym_id: gymIds,
        plan_duration: planDuration,
        member_type: subscriptionType,
        days_value: daysValue || "",
        subscription_start_date: formValues.startDate || "",
        subscription_end_date: formValues.endDate || "",
        source_name: formValues.selectedLeadSource?.value || "",
        status: formValues.selectedMemberStatus?.value || "",
        subscription_status: formValues.selectedSubscriptionStatus?.value || "",
      };

      getMembersData(sendableFilters);
    }
  }, [
    formValues.selectedRecipient,
    formValues.selectedGyms,
    formValues.selectedSubscriptionType,
    formValues.selectedPlanDuration,
    formValues.subscriptionTypeValue,
    formValues.startDate,
    formValues.endDate,
    formValues.selectedLeadSource,
    formValues.selectedMemberStatus,
    formValues.selectedSubscriptionStatus,
    formValues.selectedMemberType,
  ]);

  useEffect(() => {
    if (formValues.selectedRecipient?.value === "member") {
      const sendableFilters = {
        limit: 2000,
        page: 1,
        status: "active",
      };

      getLeadSources(sendableFilters);
    }
  }, [formValues.selectedRecipient]);

  useEffect(() => {
    if (formValues.selectedMemberType?.value === "lead") {
      const gymIds = formValues.selectedGyms
        ?.map((gym) => gym?.value)
        .join(",");

      const sendableLeadFilters = {
        page: 1,
        limit: 5000,
        lead_status: "pending",
        status: "active",
        source_name: formValues.selectedLeadSource?.value || "",
        gym_id: gymIds || "",
        // gym_id: formValues.selectedGym?.value || "",
      };

      getAllLeads(sendableLeadFilters);
    }
  }, [
    formValues.selectedMemberType,
    formValues.selectedGyms,
    formValues.selectedLeadSource,
  ]);

  useEffect(() => {
    if (
      formValues.selectedRecipient?.value === "trainer" ||
      formValues.selectedRecipient?.value === "receptionist" ||
      formValues.selectedRecipient?.value === "cluster_manager"
    ) {
      const gymIds = formValues.selectedGyms
        ?.map((gym) => gym?.value)
        .join(",");

      const sendableLeadFilters = {
        page: 1,
        limit: 5000,
        status: "active",
        gym_id: gymIds || "",
        // gym_id: formValues.selectedGym?.value || "",
      };

      if (formValues.selectedRecipient?.value === "trainer") {
        getTrainerData(sendableLeadFilters);
      }

      if (formValues.selectedRecipient?.value === "receptionist") {
        getReceptionists(sendableLeadFilters);
      }

      if (formValues.selectedRecipient?.value === "cluster_manager") {
        getClusterManagers(sendableLeadFilters);
      }
    }
  }, [formValues.selectedRecipient, formValues.selectedGyms]);

  useEffect(() => {
    if (!allLeadsLoading && allLeads?.status && allLeads?.data?.length > 0) {
      const dropdownOptions = allLeads?.data.map((item) => ({
        label: `${item.name}/${item.mobile}`,
        value: item.lead_id,
        info: item,
      }));

      setFollowUpMembers(dropdownOptions);
    } else {
      setFollowUpMembers([]);
    }
  }, [allLeadsLoading, allLeads]);

  useEffect(() => {
    if (
      !trainerDataLoading &&
      trainerData?.status &&
      trainerData?.data?.length > 0
    ) {
      const dropdownOptions = trainerData?.data.map((item) => ({
        label: `${item.name}/${item.mobile}`,
        value: item.user_id,
        info: item,
      }));

      setTrainers(dropdownOptions);
    } else {
      setTrainers([]);
    }
  }, [trainerDataLoading, trainerData]);

  useEffect(() => {
    if (
      !receptionistsLoading &&
      receptionists?.status &&
      receptionists?.data?.length > 0
    ) {
      const dropdownOptions = receptionists?.data.map((item) => ({
        label: `${item.name}/${item.mobile}`,
        value: item.user_id,
        info: item,
      }));

      setReceptionistData(dropdownOptions);
    } else {
      setReceptionistData([]);
    }
  }, [receptionistsLoading, receptionists]);

  console.log("formErrors=> ", formErrors);

  return (
    <>
      {isSubmit ? (
        <>
          <div className="form-container boradcast-log-form">
            <form className="formContainer">
              <BroadcastCampaignForm
                userInfoData={userInfoData}
                closeModal={closeModal}
                handleBack={() => setIsSubmit(false)}
                selectedMembers={selectedMembers}
                selectedRecipient={formValues.selectedRecipient?.value}
                from="custom"
                callFunction={callFunction}
                allFilters={{
                  selectedGyms: formValues.selectedGyms,
                  subscriptionTypeValue: formValues.subscriptionTypeValue,
                  selectedPlanDuration: formValues.selectedPlanDuration,
                  selectedMemberStatus: formValues.selectedMemberStatus,
                  selectedSubscriptionStatus:
                    formValues.selectedSubscriptionStatus,
                  selectedSubscriptionType: formValues.selectedSubscriptionType,
                  selectedLeadSource: formValues.selectedLeadSource,
                  startDate: formValues.startDate,
                  endDate: formValues.endDate,
                  selectedMemberType: formValues.selectedMemberType,
                  selectedRecipient: formValues.selectedRecipient,
                }}
              />
            </form>
          </div>

          {/* <ReBroadcastForm
            userInfoData={userInfoData}
            callFunction={callFunction}
            closeModal={closeModal}
            handleBack={() => setIsSubmit(false)}
            selectedMembers={selectedMembers}
            selectedRecipient={formValues.selectedRecipient?.value}
            allFilters={{
              selectedGyms: formValues.selectedGyms,
              subscriptionTypeValue: formValues.subscriptionTypeValue,
              selectedPlanDuration: formValues.selectedPlanDuration,
              selectedMemberStatus: formValues.selectedMemberStatus,
              selectedSubscriptionStatus: formValues.selectedSubscriptionStatus,
              selectedSubscriptionType: formValues.selectedSubscriptionType,
              selectedLeadSource: formValues.selectedLeadSource,
              startDate: formValues.startDate,
              endDate: formValues.endDate,
              selectedMemberType: formValues.selectedMemberType,
              selectedRecipient: formValues.selectedRecipient,
            }}
          /> */}
        </>
      ) : (
        <div className="form-container  boradcast-log-form">
          <form className="formContainer">
            <div className="formInputsGrid threeGridSystem">
              <div className="formInputBox page-name-card span3">
                <label htmlFor="selectedRecipient" className={`formInputLabel`}>
                  recipient{" "}
                  <small className="gray">
                    (Choose recipient type from the options)
                  </small>{" "}
                  <span className="required">*</span>
                </label>

                <div className="checkbox-group two-column-checkboxes">
                  {recipient_roles.map((option) => (
                    <label
                      key={option.value}
                      className="checkbox-label page-card-checkbox-lable"
                    >
                      <input
                        type="checkbox"
                        checked={
                          formValues.selectedRecipient?.value === option.value
                        }
                        onChange={() =>
                          onChangeDropdown(
                            formValues.selectedRecipient?.value === option.value
                              ? ""
                              : option,
                            "selectedRecipient"
                          )
                        }
                      />
                      <span className="custom-checkbox"></span>
                      {option.label}
                    </label>
                  ))}
                </div>
              </div>

              {formValues.selectedRecipient?.value === "member" &&
              !formValues.isAllMembers ? (
                <div className="formInputBox page-name-card span3">
                  <label
                    htmlFor="selectedMemberType"
                    className={`formInputLabel`}
                  >
                    member type{" "}
                    <small className="gray">
                      (Choose who should receive this broadcast)
                    </small>{" "}
                    <span className="required">*</span>
                  </label>

                  <div className="checkbox-group two-column-checkboxes">
                    {custom_types.map((option) => (
                      <label
                        key={option.value}
                        className="checkbox-label page-card-checkbox-lable"
                      >
                        <input
                          type="checkbox"
                          checked={
                            formValues.selectedMemberType?.value ===
                            option.value
                          }
                          onChange={() =>
                            onChangeDropdown(
                              formValues.selectedMemberType?.value ===
                                option.value
                                ? ""
                                : option,
                              "selectedMemberType"
                            )
                          }
                        />
                        <span className="custom-checkbox"></span>
                        {option.label}
                      </label>
                    ))}
                  </div>
                </div>
              ) : null}

              {(formValues.selectedRecipient?.value === "member" &&
                formValues.selectedMemberType?.value) ||
              (formValues.selectedRecipient?.value &&
                formValues.selectedRecipient?.value !== "member") ? (
                <>
                  <div className="formInputBox page-name-card span3">
                    <label htmlFor="selectedGyms" className={`formInputLabel`}>
                      Gym{" "}
                      <small className="gray">
                        (gym is optional if you don't choose gym then broadcast
                        will send to all mebers of WTF gyms)
                      </small>{" "}
                    </label>

                    <div
                      className={`commonWrapper no-border multi-select multi-show-option ${
                        formErrors?.selectedGyms ? "error" : ""
                      }`}
                    >
                      <MultiSelect
                        options={gymData?.length > 0 ? gymData : []}
                        state={formValues.selectedGyms}
                        setState={(selectedValue) =>
                          onChangeDropdown(selectedValue, "selectedGyms")
                        }
                        name="select multiple gyms"
                        isShowList={true}
                      />
                    </div>
                  </div>

                  {formValues.selectedRecipient?.value === "member" &&
                  formValues.selectedMemberType?.value === "member" ? (
                    <>
                      <div className="formInputBox page-name-card span3">
                        <label
                          htmlFor="selectedLeadSource"
                          className={`formInputLabel`}
                        >
                          Member source
                        </label>

                        <div className="checkbox-group two-column-checkboxes">
                          {leadSources?.data?.length > 0
                            ? leadSources?.data?.map((option) => (
                                <label
                                  key={option.value}
                                  className="checkbox-label page-card-checkbox-lable"
                                >
                                  <input
                                    type="checkbox"
                                    checked={
                                      formValues.selectedLeadSource?.value ===
                                      option.value
                                    }
                                    onChange={() =>
                                      onChangeDropdown(
                                        formValues.selectedLeadSource?.value ===
                                          option.value
                                          ? ""
                                          : option,
                                        "selectedLeadSource"
                                      )
                                    }
                                  />
                                  <span className="custom-checkbox"></span>
                                  {option.label}
                                </label>
                              ))
                            : null}
                        </div>
                      </div>

                      <div className="formInputBox page-name-card span3">
                        <label
                          htmlFor="selectedMemberStatus"
                          className={`formInputLabel`}
                        >
                          Member status
                        </label>

                        <div className="checkbox-group two-column-checkboxes">
                          {activeInactiveStatus?.map((option) => (
                            <label
                              key={option.value}
                              className="checkbox-label page-card-checkbox-lable"
                            >
                              <input
                                type="checkbox"
                                checked={
                                  formValues.selectedMemberStatus?.value ===
                                  option.value
                                }
                                onChange={() =>
                                  onChangeDropdown(
                                    formValues.selectedMemberStatus?.value ===
                                      option.value
                                      ? ""
                                      : option,
                                    "selectedMemberStatus"
                                  )
                                }
                              />
                              <span className="custom-checkbox"></span>
                              {option.label}
                            </label>
                          ))}
                        </div>
                      </div>

                      <div className="formInputBox page-name-card span3">
                        <label
                          htmlFor="selectedSubscriptionStatus"
                          className={`formInputLabel`}
                        >
                          Subscription Status
                        </label>

                        <div className="checkbox-group two-column-checkboxes">
                          {activeInactiveStatus?.map((option) => (
                            <label
                              key={option.value}
                              className="checkbox-label page-card-checkbox-lable"
                            >
                              <input
                                type="checkbox"
                                checked={
                                  formValues.selectedSubscriptionStatus
                                    ?.value === option.value
                                }
                                onChange={() =>
                                  onChangeDropdown(
                                    formValues.selectedSubscriptionStatus
                                      ?.value === option.value
                                      ? ""
                                      : option,
                                    "selectedSubscriptionStatus"
                                  )
                                }
                              />
                              <span className="custom-checkbox"></span>
                              {option.label}
                            </label>
                          ))}
                        </div>
                      </div>

                      <div className="formInputBox page-name-card span3">
                        <label
                          htmlFor="selectedSubscriptionType"
                          className={`formInputLabel`}
                        >
                          Subscription Type
                        </label>

                        <div className="checkbox-group two-column-checkboxes">
                          {renewal_unpaid?.map((option) => (
                            <label
                              key={option.value}
                              className="checkbox-label page-card-checkbox-lable"
                            >
                              <input
                                type="checkbox"
                                checked={
                                  formValues.selectedSubscriptionType?.value ===
                                  option.value
                                }
                                onChange={() =>
                                  onChangeDropdown(
                                    formValues.selectedSubscriptionType
                                      ?.value === option.value
                                      ? ""
                                      : option,
                                    "selectedSubscriptionType"
                                  )
                                }
                              />
                              <span className="custom-checkbox"></span>
                              {option.label}
                            </label>
                          ))}
                        </div>
                      </div>

                      {formValues.selectedSubscriptionType?.value ? (
                        <div className="formInputBox page-name-card span3">
                          <label
                            htmlFor="subscriptionTypeValue"
                            className={`formInputLabel`}
                          >
                            {formValues.selectedSubscriptionType?.label} Type
                            value{" "}
                            <small className="gray">
                              ( ⓘ{" "}
                              {formValues.selectedSubscriptionType?.value ===
                              "renewal"
                                ? "Renewal Within"
                                : "Unpaid From"}{" "}
                              {formValues.subscriptionTypeValue ||
                                (formValues.selectedSubscriptionType?.value ===
                                "renewal"
                                  ? "30"
                                  : "All")}{" "}
                              Days)
                            </small>{" "}
                          </label>

                          <div className="checkbox-group two-column-checkboxes">
                            <input
                              type="number"
                              placeholder="Enter subscription type value"
                              className={`formInput ${
                                formErrors?.subscriptionTypeValue
                                  ? "formError"
                                  : ""
                              }`}
                              name="subscriptionTypeValue"
                              value={formValues.subscriptionTypeValue}
                              onChange={onChangeInput}
                              min={0}
                              max={365}
                            />
                          </div>
                        </div>
                      ) : null}

                      <div className="formInputBox page-name-card span3">
                        <label
                          htmlFor="selectedPlanDuration"
                          className={`formInputLabel`}
                        >
                          plan duration
                        </label>

                        <div className="checkbox-group two-column-checkboxes">
                          {regularPlansDropdown?.map((option) => (
                            <label
                              key={option.value}
                              className="checkbox-label page-card-checkbox-lable"
                            >
                              <input
                                type="checkbox"
                                checked={
                                  formValues.selectedPlanDuration?.value ===
                                  option.value
                                }
                                onChange={() =>
                                  onChangeDropdown(
                                    formValues.selectedPlanDuration?.value ===
                                      option.value
                                      ? ""
                                      : option,
                                    "selectedPlanDuration"
                                  )
                                }
                              />
                              <span className="custom-checkbox"></span>
                              {option.label}
                            </label>
                          ))}
                        </div>
                      </div>

                      <div className="formInputBox page-name-card span3">
                        <label
                          htmlFor="subscriptionTypeValue"
                          className={`formInputLabel`}
                        >
                          subscription start and expire date
                          <small className="gray"></small>{" "}
                        </label>

                        <div className="input-groups two-input-groups">
                          <input
                            type="date"
                            className={`formInput ${
                              formValues.startDate ? "date-has-value" : ""
                            } ${formErrors?.startDate ? "formError" : ""}`}
                            name="startDate"
                            value={formValues.startDate}
                            onChange={onChangeInput}
                          />

                          <input
                            type="date"
                            className={`formInput ${
                              formValues.endDate ? "date-has-value" : ""
                            } ${formErrors?.endDate ? "formError" : ""}`}
                            name="endDate"
                            value={formValues.endDate}
                            onChange={onChangeInput}
                          />
                        </div>
                      </div>
                    </>
                  ) : null}

                  {formValues.isAllMembers ? null : (
                    <div className="formInputBox page-name-card span3">
                      <div className="flexBetween">
                        <label
                          htmlFor="selectedMembers"
                          className={`formInputLabel`}
                        >
                          {formValues.selectedRecipient?.label}{" "}
                          <small className="gray uppercase">
                            (total {formValues.selectedRecipient?.label}:{" "}
                            {formValues.selectedRecipient?.value === "member"
                              ? formValues.selectedMemberType?.value === "lead"
                                ? formValues.selectedFollowUpMembers?.length ||
                                  0
                                : formValues.selectedMembers?.length || 0
                              : formValues.selectedRecipient?.value ===
                                "trainer"
                              ? formValues.selectedTrainers?.length || 0
                              : formValues.selectedRecipient?.value ===
                                "receptionist"
                              ? formValues.selectedReceptionists?.length || 0
                              : formValues.selectedRecipient?.value ===
                                "cluster_manager"
                              ? formValues.selectedClusterManagers?.length || 0
                              : 0}
                            /
                            {formValues.selectedRecipient?.value === "member"
                              ? formValues.selectedMemberType?.value === "lead"
                                ? followUpMembers?.length || 0
                                : members?.length || 0
                              : formValues.selectedRecipient?.value ===
                                "trainer"
                              ? trainers?.length || 0
                              : formValues.selectedRecipient?.value ===
                                "receptionist"
                              ? receptionistData?.length || 0
                              : formValues.selectedRecipient?.value ===
                                "cluster_manager"
                              ? clusterManagers?.length || 0
                              : 0}
                            )
                          </small>
                          {formErrors?.selectedMembers && (
                            <span className="required">*</span>
                          )}
                          <button
                            type="button"
                            className="broadcast-reload-btn"
                            onClick={() => getCombinedReload()}
                          >
                            {ReloadIcon()}
                          </button>
                        </label>
                      </div>

                      {(formValues.selectedRecipient?.value === "member" &&
                        formValues.selectedMemberType?.value) ||
                      (formValues.selectedRecipient?.value &&
                        formValues.selectedRecipient?.value !== "member") ? (
                        <div className="flexEnd w100p">
                          <CloseSubmitBtn
                            closeLabel="Cancel"
                            submitLabel={"Next"}
                            onClose={closeModal}
                            onSubmit={onSumitForm}
                            isLoading={postPutLoading}
                          />
                        </div>
                      ) : null}

                      {formValues.selectedMemberType?.value === "member" ? (
                        <>
                          {loading ? (
                            <Loader />
                          ) : (
                            <div className="broadcast-selected-members">
                              <div
                                className={`commonWrapper no-border multi-select multi-show-option ${
                                  formErrors?.selectedMembers ? "error" : ""
                                }`}
                              >
                                <MultiSelect
                                  options={members?.length > 0 ? members : []}
                                  state={formValues.selectedMembers}
                                  setState={(selectedValue) =>
                                    onChangeDropdown(
                                      selectedValue,
                                      "selectedMembers"
                                    )
                                  }
                                  name="select multiple members"
                                  preventKeyboardOpen={false}
                                  isShowList={true}
                                />
                              </div>
                            </div>
                          )}
                        </>
                      ) : formValues.selectedMemberType?.value === "lead" ? (
                        <>
                          {allLeadsLoading ? (
                            <Loader />
                          ) : (
                            <div className="broadcast-selected-members">
                              <div
                                className={`commonWrapper no-border multi-select multi-show-option ${
                                  formErrors?.selectedFollowUpMembers
                                    ? "error"
                                    : ""
                                }`}
                              >
                                <MultiSelect
                                  options={followUpMembers}
                                  state={formValues.selectedFollowUpMembers}
                                  setState={(selectedValue) =>
                                    onChangeDropdown(
                                      selectedValue,
                                      "selectedFollowUpMembers"
                                    )
                                  }
                                  name="select multiple follow-up members"
                                  preventKeyboardOpen={false}
                                  isShowList={true}
                                />
                              </div>
                            </div>
                          )}
                        </>
                      ) : formValues.selectedRecipient?.value === "trainer" ? (
                        <>
                          {trainerDataLoading ? (
                            <Loader />
                          ) : (
                            <div className="broadcast-selected-members">
                              <div
                                className={`commonWrapper no-border multi-select multi-show-option ${
                                  formErrors?.selectedTrainers ? "error" : ""
                                }`}
                              >
                                <MultiSelect
                                  options={trainers}
                                  state={formValues.selectedTrainers}
                                  setState={(selectedValue) =>
                                    onChangeDropdown(
                                      selectedValue,
                                      "selectedTrainers"
                                    )
                                  }
                                  name="select multiple trainers"
                                  preventKeyboardOpen={false}
                                  isShowList={true}
                                />
                              </div>
                            </div>
                          )}
                        </>
                      ) : formValues.selectedRecipient?.value ===
                        "receptionist" ? (
                        <>
                          {trainerDataLoading ? (
                            <Loader />
                          ) : (
                            <div className="broadcast-selected-members">
                              <div
                                className={`commonWrapper no-border multi-select multi-show-option ${
                                  formErrors?.selectedReceptionists
                                    ? "error"
                                    : ""
                                }`}
                              >
                                <MultiSelect
                                  options={receptionistData}
                                  state={formValues.selectedReceptionists}
                                  setState={(selectedValue) =>
                                    onChangeDropdown(
                                      selectedValue,
                                      "selectedReceptionists"
                                    )
                                  }
                                  name="select multiple receptionists"
                                  preventKeyboardOpen={false}
                                  isShowList={true}
                                />
                              </div>
                            </div>
                          )}
                        </>
                      ) : formValues.selectedRecipient?.value ===
                        "cluster_manager" ? (
                        <>
                          {clusterManagersLoading ? (
                            <Loader />
                          ) : (
                            <div
                              className={`commonWrapper no-border multi-select multi-show-option ${
                                formErrors?.selectedClusterManagers
                                  ? "error"
                                  : ""
                              }`}
                            >
                              <MultiSelect
                                options={
                                  clusterManagers?.length > 0
                                    ? clusterManagers
                                    : []
                                }
                                state={formValues.selectedClusterManagers}
                                setState={(selectedValue) =>
                                  onChangeDropdown(
                                    selectedValue,
                                    "selectedClusterManagers"
                                  )
                                }
                                name="select multiple cluster managers"
                                preventKeyboardOpen={false}
                                isShowList={true}
                              />
                            </div>
                          )}
                        </>
                      ) : null}

                      <span className="tiny-info-label">
                        ⓘ Upto 5000 {formValues.selectedRecipient?.label} can be
                        fetched at a time!
                      </span>
                    </div>
                  )}
                </>
              ) : null}
            </div>

            {(formValues.selectedRecipient?.value === "member" &&
              formValues.selectedMemberType?.value) ||
            (formValues.selectedRecipient?.value &&
              formValues.selectedRecipient?.value !== "member") ? (
              <CloseSubmitBtn
                closeLabel="Cancel"
                submitLabel={"Next"}
                onClose={closeModal}
                onSubmit={onSumitForm}
                isLoading={postPutLoading}
              />
            ) : null}
          </form>
        </div>
      )}
    </>
  );
};

export default BroadcastTemplateForm;
